'use client';

import { useEffect, useRef, useState } from 'react';
import OptimizedImage from './OptimizedImage';
import videos from '../content/optimized-videos.json';
import { attachHeroVideo } from '../lib/hero-video';

export function HeroVideo({ src, poster }) {
  const variants = videos[src];
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    setIsPlaying(false);
    const controller = attachHeroVideo(videoRef.current, state => setIsPlaying(state.playing));
    return () => controller.cleanup();
  }, [src]);

  return <div className="hero-media" aria-hidden="true">
    <picture>
      {variants?.mobilePoster && <source media="(max-width: 767px)" srcSet={variants.mobilePoster}/>}
      <OptimizedImage className="hero-poster" src={variants?.desktopPoster || poster} alt="" sizes="100vw"
        width={variants?.width} height={variants?.height} fetchPriority="high"/>
    </picture>
    <video ref={videoRef} data-src={variants?.desktop || src} data-mobile-src={variants?.mobile} autoPlay loop muted playsInline
      preload="none" disablePictureInPicture controls={false} tabIndex={-1}
      style={{ opacity: isPlaying ? 1 : 0 }}/>
  </div>;
}
